import { QueryString } from '@grandvisionhq/utils';

const getFormattedParams = ({ storeId , typeId , linkedAppointmentTypeId , alternativeLinkedAppointmentTypeId , start , end , appointmentId , virtualStoreCode , virtualAppointmentTypeId , alternativeUrlStores , tryInStoreFlow , tryInStoreProductSkus  })=>{
    return {
        storeId: storeId !== undefined ? parseInt(storeId, 10) : undefined,
        typeId,
        linkedAppointmentTypeId,
        alternativeLinkedAppointmentTypeId,
        start: (start === null || start === void 0 ? void 0 : start.length) ? start : undefined,
        end: (end === null || end === void 0 ? void 0 : end.length) ? end : undefined,
        appointmentId: appointmentId !== null && appointmentId !== void 0 ? appointmentId : undefined,
        virtualStoreCode: virtualStoreCode !== undefined ? parseInt(virtualStoreCode, 10) : undefined,
        virtualAppointmentTypeId,
        alternativeUrlStores: alternativeUrlStores === null || alternativeUrlStores === void 0 ? void 0 : alternativeUrlStores.split(',').map((string)=>parseInt(string, 10)
        ),
        tryInStoreFlow: tryInStoreFlow ? true : undefined,
        tryInStoreProductSkus: tryInStoreProductSkus === null || tryInStoreProductSkus === void 0 ? void 0 : tryInStoreProductSkus.split(',').map((string)=>string
        )
    };
};
const hasValidVirtualAppointmentConfig = (params)=>params.virtualStoreCode !== undefined && params.virtualAppointmentTypeId !== undefined
;
const hasValidVirtualAppointmentParams = (params)=>hasValidVirtualAppointmentConfig(params) && params.typeId === params.virtualAppointmentTypeId && params.storeId === params.virtualStoreCode
;
const hasInvalidVirtualAppointmentParams = (params)=>hasValidVirtualAppointmentConfig(params) && (params.typeId === params.virtualAppointmentTypeId && params.storeId !== params.virtualStoreCode || params.typeId !== params.virtualAppointmentTypeId && params.storeId === params.virtualStoreCode)
;
const replaceCurrentRoute = (baseUrl, asPath, currentRoute, newRoute, queryParams)=>{
    const cleanAsPath = asPath.replace(currentRoute, newRoute).split('?')[0];
    const clearQueryParameters = QueryString.stringify(queryParams, Object.entries(queryParams).length === 0);
    return `${baseUrl}${cleanAsPath}${clearQueryParameters}`;
};
const isAppointmentTypeValid = ({ store , typeId  })=>{
    var ref;
    return Boolean(store === null || store === void 0 ? void 0 : (ref = store.appointmentTypes) === null || ref === void 0 ? void 0 : ref.find(({ id  })=>id === typeId
    ));
};
const generateVirtualAppointmentStoreData = (code, virtualAppointmentType)=>({
        code,
        name: '[placeholder-virtual-appointment-store-name]',
        shortName: '[placeholder-virtual-appointment-store-short-name]',
        streetName: '[placeholder-virtual-appointment-store-street-name]',
        streetNumber: undefined,
        additionalStreetInfo: undefined,
        postalCode: undefined,
        province: undefined,
        town: '[placeholder-virtual-appointment-store-town]',
        country: '[placeholder-virtual-appointment-store-country]',
        lat: undefined,
        lon: undefined,
        phone: '[placeholder-virtual-appointment-store-phone]',
        emailAddress: undefined,
        appointmentTypes: [
            virtualAppointmentType
        ]
    })
;

export { generateVirtualAppointmentStoreData, getFormattedParams, hasInvalidVirtualAppointmentParams, hasValidVirtualAppointmentConfig, hasValidVirtualAppointmentParams, isAppointmentTypeValid, replaceCurrentRoute };
//# sourceMappingURL=utils.js.map
